import { SUBSCRIPTION_COMPONENT_TRANSLATIONS as T } from "@/components/subscription/constants";
import { Button } from "@/domains/shared/components/Button";
import { normalizePlanSlug, SubscriptionPlanIds } from "@/domains/subscription/plans";
import { getTranslation } from "@mivo/i18n";

type FreeBasicTrialConfirmStepProps = {
    onCancel: () => void;
    onConfirm: () => void;
};

export function FreeBasicTrialConfirmStep({ onCancel, onConfirm }: FreeBasicTrialConfirmStepProps) {
    return (
        <div className="space-y-4 text-sm text-muted-foreground" data-testid="checkout-free-basic-trial-confirm">
            <p>{getTranslation(T.freeBasicTrialDays)}</p>
            <p>{getTranslation(T.freeBasicTrialCardCharge)}</p>
            <p>{getTranslation(T.freeBasicTrialCancelStayFree)}</p>
            <div className="flex flex-row gap-2">
                <Button
                    type="button"
                    variant="outline"
                    className="flex-1"
                    data-testid="checkout-free-basic-trial-cancel"
                    onClick={onCancel}
                >
                    {getTranslation(T.cancel)}
                </Button>
                <Button
                    type="button"
                    className="flex-1"
                    data-testid="checkout-free-basic-trial-agree"
                    onClick={onConfirm}
                >
                    {getTranslation(T.agreeAndContinue)}
                </Button>
            </div>
        </div>
    );
}

export function requiresFreeBasicTrialConfirmation(
    currentPlanId: string | null | undefined,
    targetPlanId: string | null | undefined,
    canStartBasicTrial: boolean | null | undefined,
): boolean {
    if (!canStartBasicTrial) {
        return false;
    }

    const current = normalizePlanSlug(currentPlanId);
    const target = normalizePlanSlug(targetPlanId);
    return current === SubscriptionPlanIds.free && target === SubscriptionPlanIds.basic;
}
